/**
 * Whether a place slot is ready to be sent to GTM.
 * Slug-only placeholders (autocomplete fetch pending) are not ready.
 * Empty slots (no slug) are ready — treated as "no selection".
 *
 * @param {{ slug?: string, cityName?: string }} [place]
 * @returns {boolean}
 */
const isPlaceReady = place => !place?.slug || Boolean(place.cityName);

export default isPlaceReady;
